import { gql } from "@apollo/client";

export const SAVE_PARTNER = gql`
  mutation savePartner($input: SavePartnerInput!) {
    savePartner(input: $input) {
      commandId
      correlationId
    }
  }
`;
